export { CommBanner } from './CommBanner'
export type { CommBannerProps } from './CommBanner'
